export default __webpack_public_path__ + "static/media/SLIDE_ESCALERAS_6.e72e91fc.jpg";